/**
 * @module M/control/TextStyle
 */
import Draggabilly from 'draggabilly';
import TextStyleImpl from 'impl/textStyle';
import template from 'templates/styletext';
import { getValue } from './i18n/language';

const radInDeg = Math.PI / 180;
const degInRad = 180 / Math.PI;

export default class TextStyle extends M.Control {
  /**
   * @classdesc
   * Main constructor of the class. Creates a PluginControl
   * control
   *
   * @constructor
   * @extends {M.Control}
   * @api stable
   */
  constructor(plugin, features) {
    // 1. checks if the implementation can create PluginControl
    if (M.utils.isUndefined(TextStyleImpl)) {
      M.exception('La implementación usada no puede crear controles TextStyleImpl');
    }

    // 2. implementation of this control
    const impl = new TextStyleImpl();
    super(impl, 'TextStyle');
    this.plugin = plugin;
    this.features = features;
    const feature = features[0];
    this.textOriginal = [];
    this.textOriginal[0] = feature.getStyle().getText().font_.includes('bold') ? 'bold' : '';
    this.textOriginal[1] = feature.getStyle().getText().font_.includes('italic') ? 'italic' : '';
    this.textOriginal[2] = feature.getStyle().getText().font_.replace(/\D/g, '');
    this.textOriginal[3] = feature.getStyle().getText().font_.split('px ');
    this.textOriginal[3] = this.textOriginal[3][1];
    this.texto = this.features[0].getStyle().getText().getText();
    this.color = this.features[0].getStyle().getText().getFill().getColor();
    const radians = this.features[0].getStyle().getText().getRotation() || 0;
    this.rotation = radians * degInRad;
    this.setStyleWithBorder();
  }

  /**
   * This function creates the view
   *
   * @public
   * @function
   * @param {M.Map} map to add the control
   * @api stable
   */
  createView(map) {
    const html = M.template.compileSync(template, {
      vars: {
        translations: {
          options: getValue('options'),
          size: getValue('size'),
          colour: getValue('colour'),
          thickness: getValue('thickness'),
          style: getValue('style'),
          frameColour: getValue('frameColour'),
          backgroundColour: getValue('backgroundColour'),
          text: getValue('text'),
          font: getValue('font'),
          bold: getValue('bold'),
          italic: getValue('italic'),
          rotation: getValue('rotation'),
        },
      },
    });
    const bold = html.querySelector('button#m-feature-freedrawing-fbold');
    if (this.textOriginal[0] === 'bold') {
      bold.classList.toggle('m-freedrawig-dialog-button-active');
    }
    const cursive = html.querySelector('button#m-feature-freedrawing-fcursive');
    if (this.textOriginal[1] === 'italic') {
      cursive.classList.toggle('m-freedrawig-dialog-button-active');
    }
    const texto = html.querySelector('input#m-feature-freedrawing-ftext');
    texto.value = this.texto;
    const font = html.querySelector('select#m-feature-freedrawing-ffont');
    font.value = this.textOriginal[3];
    const sizeFont = html.querySelector('input#m-feature-freedrawing-fsizefont');
    sizeFont.value = this.textOriginal[2];
    const colorFont = html.querySelector('input#m-feature-freedrawing-fcolorfont');
    colorFont.value = this.color;
    const rotationFont = html.querySelector('input#m-feature-freedrawing-fsizerotation');
    rotationFont.value = this.rotation;
    const destroyPlugin = html.querySelector('button#destroy-plugin');
    const rotationBtn = html.querySelector('button#m-feature-freedrawing-fsizerotation-start');
    const changeBold = function(event) {
      bold.classList.toggle('m-freedrawig-dialog-button-active');
      this.features.forEach((feature) => {
        if (this.textOriginal[0] == '') {
          feature.getStyle().getText().setFont(('bold ' + this.textOriginal[1] + ' ' + this.textOriginal[2] + 'px ' + this.textOriginal[3]).trim());
          this.textOriginal[0] = 'bold';
        } else {
          feature.getStyle().getText().setFont((this.textOriginal[1] + ' ' + this.textOriginal[2] + 'px ' + this.textOriginal[3]).trim());
          this.textOriginal[0] = '';
        }
        feature.changed();
      });
    };
    const changeItalic = function(event) {
      cursive.classList.toggle('m-freedrawig-dialog-button-active');
      this.features.forEach((feature) => {
        if (this.textOriginal[1] == '') {
          feature.getStyle().getText().setFont((this.textOriginal[0] + ' italic ' + this.textOriginal[2] + 'px ' + this.textOriginal[3]).trim());
          this.textOriginal[1] = 'italic';
        } else {
          feature.getStyle().getText().setFont((this.textOriginal[0] + ' ' + this.textOriginal[2] + 'px ' + this.textOriginal[3]).trim());
          this.textOriginal[1] = '';
        }
        feature.changed();
      });
    };
    const functionDestroyPlugin = function(event) {
      this.setStyleWithoutBorder();
      this.plugin.destroyControl();
    };
    destroyPlugin.addEventListener('click', functionDestroyPlugin.bind(this));
    bold.addEventListener('click', changeBold.bind(this, bold));
    cursive.addEventListener('click', changeItalic.bind(this, cursive));
    const changeText = function(event) {
      this.features.forEach((feature) => {
        feature.getStyle().getText().setText(texto.value);
        feature.changed();
        this.texto = texto.value;
      });
    };

    const changeFont = function(event) {
      this.features.forEach((feature) => {
        feature.getStyle().getText().setFont((this.textOriginal[0] + ' ' + this.textOriginal[1] + ' ' + this.textOriginal[2] + 'px ' + font.value).trim());
        feature.changed();
        this.textOriginal[3] = font.value;
      });
    };

    const changeSize = function(event) {
      this.features.forEach((feature) => {
        feature.getStyle().getText().setFont((this.textOriginal[0] + ' ' + this.textOriginal[1] + ' ' + sizeFont.value + 'px ' + this.textOriginal[3]).trim());
        feature.changed();
        this.textOriginal[2] = sizeFont.value;
      });
    };

    const changeColor = function(event) {
      this.features.forEach((feature) => {
        feature.getStyle().getText().setFill(new ol.style.Fill({ color: colorFont.value }));
        feature.changed();
        this.color = colorFont.value;
      });
    };

    const changeRotation = function(event) {
      this.features.forEach((feature) => {
        feature.getStyle().getText().setRotation(rotationFont.value * radInDeg);
        feature.changed();
        this.rotation = rotationFont.value;
      });
    };

    const changeRotationBtn = function(event) {
      rotationFont.value = 0;
      this.features.forEach((feature) => {
        feature.getStyle().getText().setRotation(0);
        feature.changed();
        this.rotation = 0;
      });
    };

    colorFont.addEventListener('change', changeColor.bind(this, colorFont));
    texto.addEventListener('keyup', changeText.bind(this, texto));
    font.addEventListener('change', changeFont.bind(this, font));
    sizeFont.addEventListener('change', changeSize.bind(this, sizeFont));
    rotationFont.addEventListener('change', changeRotation.bind(this, rotationFont));
    rotationBtn.addEventListener('click', changeRotationBtn.bind(this, rotationFont));
    setTimeout(() => {
      const elem = document.querySelector('.m-panel.m-tools-styleTools');
      if (elem !== null) {
        const draggable = new Draggabilly(elem, {
          containment: '.m-mapea-container',
          handle: '#styleToolsHTML > div > div.title',
        });

        draggable.enable();
      }
    }, 300);

    return html;
  }

  setStyleWithBorder() {
    const drawLayer = this.plugin.map.getLayers().filter(l => l.name === '__draw__')[0];
    const drawnFeatures = drawLayer.getImpl().getOL3Layer().getSource().getFeatures();
    drawnFeatures.forEach((f) => {
      if (typeof f.getStyle().getText === 'function' && (f.getStyle().getText() !== null && f.getStyle().getText() !== undefined)) {
        f.getStyle().getText().setBackgroundStroke(null);
        const newStyleFunction = f.styleFunction_;
        const newStyle = f.getStyle();
        f.setStyle(newStyle);
        /* eslint-disable-next-line no-param-reassign */
        f.styleFunction_ = newStyleFunction;
      }
    });

    this.features.forEach((feature) => {
      const auxText = feature.getStyle().getText();
      auxText.setText(this.texto);
      auxText.setFont((this.textOriginal[0] + ' ' + this.textOriginal[1] + ' ' + this.textOriginal[2] + 'px ' + this.textOriginal[3]).trim());
      auxText.setFill(new ol.style.Fill({ color: this.color }));
      auxText.setRotation((this.rotation * radInDeg));
      auxText.setBackgroundStroke(new ol.style.Stroke({ color: 'rgba(255, 255, 0, 1)', width: 1 }));
    });
  }

  setStyleWithoutBorder() {
    this.features.forEach((feature) => {
      feature.getStyle().getText().setBackgroundStroke(null);
      feature.changed();
    });
  }

  /**
   * This function compares controls
   *
   * @public
   * @function
   * @param {M.Control} control to compare
   * @api stable
   */
  equals(control) {
    return control instanceof TextStyle;
  }

  // Add your own functions
}
